<div class="content-wrapper" style="margin-bottom: 100px">
  <div class="col-md-12 layout-spacing" style="margin-top: 30px">
    <div class="row">
      <div class="col-md-4">
        <div class="card" style="align-items: center">
          <img
            class="card-img-top img-fluid"
            src="assets/img/DataClasification.png"
            alt="Card image cap"
          />
          <div class="card-body card-btns" style="width: fit-content">
            <a
              href="https://purview.microsoft.com/datalossprevention/overview"
              target="_blank"
              class="btn btn-primary btn-rounded"
              style="width: 100%"
              >{{ 'dataClasification.dashboard' | translate }}</a
            >
            <a
              href="https://purview.microsoft.com/datalossprevention/investigation/multicloudcontentexplorer"
              target="_blank"
              class="btn btn-primary btn-rounded"
              style="width: 100%"
              >{{ 'dataClasification.contentExplorer' | translate }}</a
            >
            <a
              href="https://purview.microsoft.com/datalossprevention/dataclassification/multicloudsensitiveinfotypes"
              target="_blank"
              class="btn btn-primary btn-rounded"
              style="width: fit-content"
              >{{
                'dataClasification.typeOfConfidentialInformation' | translate
              }}</a
            >
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div
          class="card text-white bg-pink text-xs-center"
          style="height: 100%"
        >
          <div class="card-body" style="padding: 1.9rem">
            <h3 style="font-size: 1.5rem">
              <strong>{{ 'dataClasification.labelsUse' | translate }}</strong>
            </h3>
            <blockquote class="card-bodyquote">
              <p style="font-size: 1rem" class="mb-3 mt-3">
                {{ 'dataClasification.title' | translate }}
              </p>
              <p style="font-size: 1rem" class="mb-3">
                {{ 'dataClasification.subtitle1' | translate }}
              </p>
              <p style="font-size: 1rem" class="mb-3">
                {{ 'dataClasification.subtitle2' | translate }}
              </p>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
